import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackEvent, trackLearningEvent, trackAudioPlay, trackAuthEvent, trackAdminEvent, trackNavigation } from '../utils/analytics';

// Hook to automatically track page views
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page title based on current route
    const getPageTitle = (pathname) => {
      switch (pathname) {
        case '/':
          return 'Home - Learn Japanese';
        case '/alphabets':
          return 'Japanese Alphabets - Learn Japanese';
        case '/words':
          return 'Japanese Words - Learn Japanese';
        case '/sentences':
          return 'Japanese Sentences - Learn Japanese';
        default:
          return 'Learn Japanese';
      }
    };

    const title = getPageTitle(location.pathname);
    trackPageView(location.pathname, title);
  }, [location]);
};

// Hook for learning-specific analytics
export const useAnalytics = () => {
  return {
    // Track general events
    trackEvent,
    
    // Track learning interactions
    trackLearning: (action, contentType, contentId) => {
      trackLearningEvent(action, contentType, contentId);
    },
    
    // Track audio playback
    trackAudio: (contentType, contentId) => {
      trackAudioPlay(contentType, contentId);
    },
    
    // Track authentication events
    trackAuth: (action, method) => {
      trackAuthEvent(action, method);
    },
    
    // Track admin actions
    trackAdmin: (action, contentType, contentId) => {
      trackAdminEvent(action, contentType, contentId);
    },
    
    // Track navigation
    trackNav: (section) => {
      trackNavigation(section);
    },
  };
};
